import { _APIHandler } from "../utils/helper";

let baseUrl = "quotations";
export const fetchQuotations = () => _APIHandler.get(`${baseUrl}`);
export const fetchQuotation = (id) => _APIHandler.get(`${baseUrl}/${id}`);
export const fetchSellerQuotations = () => _APIHandler.get(`${baseUrl}/seller`);
export const fetchQuotationsComparison = (purchase_request_id) => _APIHandler.get(`${baseUrl}/${purchase_request_id}/compare`);
export const createRFQ = (data) => _APIHandler.post(`${baseUrl}/rfq`, data);
export const sendQuotation = (data) => _APIHandler.post(`${baseUrl}/send`, data);